import * as T_T from 'cryface';
import { cloneDeep } from 'lodash';

export function hybridShareCommunityEmploymentOptions(vs: any) {
    const sum = T_T.sum(vs.Data.map((v: any) => (Number(v['Value']))));
    const t1 = [
        'Health occupations',
        'Occupations in education, law and social, community and government services',
        'Occupations in art, culture, recreation and sport',
    ];
    const t2 = [
        'Trades, transport and equipment operators and related occupations',
        'Business, finance and administration occupations',
        'Sales and service occupations',
    ];
    const t3 = [
        'Occupations in manufacturing and utilities',
        'Management occupations',
    ];
    const colorPicker = (key: any) => {
        if (t1.indexOf(key) > -1) {
            return '#129ce6';
        }
        // if (t2.indexOf(key) > -1) {
        //     return '#e69c12';
        // }
        return 'rgb(128,128,128)';
    };
    const data: any = vs.Data.map((v: any) => ({
        name: `${T_T.trunc(v['Key'], 50, '...')}: (${Math.round(Number(v['Value']) / sum * 10000) / 100}%)`,
        value: Number(v['Value']),
        title: `${v['Key']}`,
        share: Math.round(Number(v['Value']) / sum * 10000) / 100,
        color: colorPicker(v['Key']),
    })).sort((a: any, b: any) => b.value - a.value);
    return data;
}
